import { Box, Typography } from '@mui/material';
import { roomTypesSpriteSrc } from '../../assets/wallet';

/** Figma 11059:1189/1194/1199 — sprite offsets for the three room coin icons */
const ROOM_TYPES = [
  { id: 'family', label: 'Family', spriteLeft: '-23.25%' },
  { id: 'kitty', label: 'Kitty', spriteLeft: '-143.19%' },
  { id: 'corporate', label: 'Corporate', spriteLeft: '-268.3%' },
];

function RoomTypeIcon({ spriteLeft }) {
  return (
    <Box sx={{ position: 'relative', width: 24, height: 24, flexShrink: 0, overflow: 'hidden' }}>
      <Box
        component="img"
        src={roomTypesSpriteSrc}
        alt=""
        aria-hidden="true"
        sx={{
          position: 'absolute',
          width: '384%',
          height: '250.98%',
          maxWidth: 'none',
          left: spriteLeft,
          top: '-75.25%',
          display: 'block',
          pointerEvents: 'none',
        }}
      />
    </Box>
  );
}

/** Figma 11059:1187 — Family / Kitty / Corporate room count chips */
export default function VipRoomBreakdown({ counts = {} }) {
  return (
    <Box sx={{ display: 'flex', gap: '10px', width: '100%' }}>
      {ROOM_TYPES.map((room) => (
        <Box
          key={room.id}
          sx={{
            flex: 1,
            minWidth: 0,
            height: 50,
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            pl: '12px',
            pr: 1,
            borderRadius: '16px',
            bgcolor: 'rgba(0, 0, 0, 0.4)',
          }}
        >
          <RoomTypeIcon spriteLeft={room.spriteLeft} />
          <Box sx={{ minWidth: 0 }}>
            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontSize: 10,
                lineHeight: '12px',
                color: '#fff',
                whiteSpace: 'nowrap',
              }}
            >
              {room.label}
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 600,
                fontSize: 16,
                lineHeight: '24px',
                letterSpacing: '0.8px',
                color: '#fff',
              }}
            >
              {String(counts[room.id] ?? 0).padStart(2, '0')}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
